var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-generator__field-warnings"},_vm._l((_vm.warnings),function(text,index){return _c('p',{key:index},[_vm._v(" "+_vm._s(text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }